export const DOT_VERT = `
  attribute vec3 aFlat;
  uniform float uMorph;
  uniform float uSize;
  uniform float uReveal;
  varying float vBack;
  void main() {
    vec3 dir = normalize((modelMatrix * vec4(position, 1.0)).xyz);
    vBack = smoothstep(0.06, -0.06, dir.z) * (1.0 - uMorph);
    gl_Position = projectionMatrix * modelViewMatrix * vec4(mix(position, aFlat, uMorph), 1.0);
    gl_PointSize = uSize * clamp(uReveal, 0.0, 2.0);
  }
`;

export const DOT_FRAG = `
  uniform vec3 uColor;
  uniform float uReveal;
  varying float vBack;
  void main() {
    if (uReveal < 0.02 || vBack > 0.99) discard;
    vec2 c = gl_PointCoord - 0.5;
    if (dot(c, c) > 0.25) discard;
    gl_FragColor = vec4(uColor, 1.0 - vBack);
  }
`;
